<template>
  <div class="about" style="background-color: #daeced; min-height: 45rem;">
    <v-container>
      <v-row class="justify-center">
        <v-col cols="11" sm="8">
          <!--Here starts Experience-->

          <v-row class="mt-5 mb-5">
            <v-col><h3>📲 Experience</h3></v-col>
            <v-col col="6" sm="4"><v-btn
                color="primary"
                href="/doc/webcv_en.pdf"
                target="_blank"
                rounded="xl"
                @click="trackClick" 
                id="resume_cv_button"
                block>
                 Download CV
                </v-btn></v-col>
            
          </v-row>
          <v-row>
            <v-col class="bg-white pa-5">
              <v-row class="pl-5">
                <v-col cols="11" class="d-lg-inline-flex align-center">
                  <div class="text-subtitle-1 font-weight-regular mr-5">Sr. iOS Developer</div>
                  <div class="text-subtitle-2 font-weight-light">IBM | January 2025 - Present</div>
                </v-col>
              </v-row>

              <v-row class="pl-5">
                <v-col cols="11" class="d-lg-inline-flex align-center">
                <div class="text-subtitle-1 font-weight-regular mr-5">Sr. iOS Developer</div>
                <div class="text-subtitle-2 font-weight-light">Banregio | April 2022 - August 2022</div>
                </v-col>
              </v-row>

              <v-row class="pl-5">
                <v-col cols="11" class="d-lg-inline-flex align-center">
                <div class="text-subtitle-1 font-weight-regular mr-5">Sr. iOS Developer</div>
                <div class="text-subtitle-2 font-weight-light">Todito Pagos S.A. de C.V. | January 2018 - April 2022</div>
                </v-col>
              </v-row>

              <v-row class="pl-5">
                <v-col cols="11" class="d-lg-inline-flex align-center">
                <div class="text-subtitle-1 font-weight-regular mr-5">Lead Project Manager</div>
                <div class="text-subtitle-2 font-weight-light">Preparatoria 1 (UANL) | April 2017 - September 2017</div>
                </v-col>
              </v-row>

              <v-row class=" pl-5">
                <v-col cols="11" class="d-lg-inline-flex align-center">
                <div class="text-subtitle-1 font-weight-regular mr-5">Senior Front-End Developer</div>
                <div class="text-subtitle-2 font-weight-light">Trading Pal | April 2017 - January 2018</div>
                </v-col>
              </v-row>

            </v-col>
          </v-row>

          <!--Here starts Education-->

          <v-row class="mt-5 mb-5">
            <v-col><h3>👨🏻‍🎓 Education</h3></v-col>
          </v-row>
          <v-row>
            <v-col class="bg-white pa-5">
              <v-row class="pl-5">
                <v-col col="11">
                  <div class="text-subtitle-1 font-weight-regular mr-5">BS in Software Technology Engineer</div>
                  <div class="text-subtitle-2 font-weight-light">Holding a Bachelor's degree from Universidad Autónoma de Nuevo León at México | 2010 to 2015.</div>
                </v-col>
              </v-row>

              <v-row class="pl-5">
                <v-col col="11">
                  <div class="text-subtitle-1 font-weight-regular mr-5">MSc in AI for Business</div>
                  <div class="text-subtitle-2 font-weight-light">Holding a Master's degree from National College of Ireland at Ireland | 2024 to 2025.</div>
                </v-col>
              </v-row>

            </v-col>
          </v-row>

           <!--Here starts Skills-->

          <v-row class="mt-5 mb-5">
            <v-col class="bg-white">
              <h3>💡 Skills</h3>
                <v-row class="text-subtitle-2 font-weight-light pa-5 ml-1">
                  <v-col cols="6">Problem-solving</v-col>
                  <v-col cols="6">Responsibility</v-col>
                  <v-col cols="6">Leadership</v-col>
                  <v-col cols="6">Creativity</v-col>
                  <v-col cols="6">Loyalty</v-col>
                </v-row>
              
              <h3>🌎 Languages</h3>

              <v-row class="text-subtitle-2 font-weight-light pa-5 ml-1">
                  <v-col cols="6">Spanish (native)</v-col>
                  <v-col cols="6">English (proficient)</v-col>
                 
                </v-row>
              <h3>✈️ Interests</h3>

              <v-row class="text-subtitle-2 font-weight-light pa-5 ml-1">
                  <v-col cols="6">Entrepreneur</v-col>
                  <v-col cols="6">Travelling</v-col>
                  <v-col cols="6">Outdoors</v-col>
                  <v-col cols="6">Drone Pilot</v-col>
                 
                </v-row>
            </v-col>
          </v-row>



        </v-col>
      </v-row>
    </v-container>
    
  </div>
</template>

<script setup>
import { useGtag } from 'vue-gtag-next'
const { event } = useGtag()

const trackClick = (e) => {
  const id = e.currentTarget.id || 'unknown'
  event(id, {
    event_category: 'button',
    event_label: id,
    value: 1,
  })
}
</script>